import { Injectable } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { HttpService } from '../service/http.service';
import { SavedSearch } from '../saved-search';
import { SearchRule } from '../search-rule';
import { SimpleBooking } from '../simple-booking';
import { ToastMessageService } from '../toast-message.service';
import { forkJoin } from 'rxjs';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class BookingsSearchService {

  public savedSearchList: SavedSearch[] = [];
  public isSavedSearchesVisible = false;
  public savedSearchForm!: FormGroup;
  savedSearchEditForms: (FormGroup | null)[] = [];
  searchRules: SearchRule[] = [];
  bookings: SimpleBooking[] = [];
  loading: boolean = false;
  recordNumber: number = 0;
  recordsByPage: number = 100;

  favoriteSearches: SavedSearch[] = [];

  constructor(
    private httpService: HttpService,
    private toastService: ToastMessageService
  ) { }

  showSavedSearches() {
    this.isSavedSearchesVisible = true;
    this.refreshSavedSearchList();
  }

  getRulesFormArray(index: number){
    let formArray = this.savedSearchEditForms[index]!.get('rules') as FormArray;
    return formArray.controls;
  }

  refreshSavedSearchList(){
    this.httpService.getPublicAndOwnedSavedSearches().subscribe(res => {
      this.savedSearchList = res;
      for (let search of this.savedSearchList) {
        this.savedSearchEditForms.push(null);
      }
    });
  }

  hideSavedSearches() {
    this.isSavedSearchesVisible = false;
  }

  getFavoriteSearches(){
    this.httpService.getFavoriteSavedSearches().subscribe(res => {
      this.favoriteSearches = res;
    });
  }

  clearSearchRules(){
    this.searchRules = [];
  }

  deleteFavoriteSearch(search: SavedSearch){
    this.httpService.removeFavoriteSavedSearch(search).subscribe(() => {
      this.toastService.addSuccess("Success", "Saved search " + search.id + " has been removed from favorite.");
      search.isFavorite = false;
      this.updateSavedSearchListWithFavorite(search.id!);
      this.getFavoriteSearches();
    }, error => this.toastService.addError("Error", error.error.message));
  }

  updateSavedSearchListWithFavorite(searchId: number){
    for(let search of this.savedSearchList){
      if(search.id == searchId){
        search.isFavorite = false;
      }
    }
  }

  loadSavedSearchById(id: number) {
    this.loading = true;
    this.httpService.getSearchRulesBySavedSearchId(id).subscribe(rules => {
      for(let rule of rules){
        if(rule.dateValue){
          rule.dateValue = moment(rule.dateValue).utc(true);
        }
      }
      this.searchRules = rules;
      forkJoin({
        bookings: this.httpService.getBookingsCustom(this.searchRules, this.recordsByPage, 0),
        recordNumber: this.httpService.getBookingsCustomRecordNumber(this.searchRules)
      }).subscribe(({bookings, recordNumber}) => {
        this.loading = false;
        this.bookings = bookings;
        this.recordNumber = recordNumber;
      });
    });
  }
}
